module.exports = __webpack_public_path__ + "img/02.30596750.png";